export default function () {
  return [
    {
      id: 0,
      color: 'black',
      hex: '#000',
    },
    {
      id: 1,
      color: 'darkgrey',
      hex: '#474747',
    },
    {
      id: 2,
      color: 'grey',
      hex: '#9b9b9b',
    },
    {
      id: 3,
      color: 'beige',
      hex: '#af903a',

    },
    {
      id: 4,
      color: 'olive',
      hex: '#495e21',
    },
    {
      id: 5,
      color: 'blue',
      hex: '#1a3d75',
    },
    {
      id: 6,
      color: 'plum',
      hex: '#510b42',
    },
    {
      id: 7,
      color: 'red',
      hex: '#960000',
    },
    {
      id: 8,
      color: 'skyblue',
      hex: '#a9f3ff',
    },
    {
      id: 9,
      color: 'yellow',
      hex: '#fff9a9',
    },
    {
      id: 10,
      color: 'white',
      hex: '#ffffff',
    }
  ]
}
